module.exports = __webpack_public_path__ + "img/hr-heat-pipe-ending-down-1.c1e8f3c5.png";